import React from 'react';
import { Modal, Table, message } from 'antd';
import Context from '../../layout/Container/Context';

export default ({ currentImName, onCancel, onOk }) => {
  const [visible, setVisible] = React.useState(false);
  const [dataSource, setDataSource] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);

  const { agentList } = React.useContext(Context);

  React.useEffect(() => {
    setVisible(true);
    setDataSource(agentList.filter((item) => item.agentImUsername !== currentImName));
  }, []);

  const handleCancel = () => {
    setVisible(false);
    onCancel && onCancel();
  };

  const handleOk = () => {
    if (selectedRows.length === 0) {
      message.warn('请选择一条数据');
      return;
    }
    setVisible(false);
    onOk && onOk(selectedRows[0]);
  };

  return (
    <Modal
      title="选择沟通账号"
      visible={visible}
      width={500}
      onCancel={handleCancel}
      onOk={handleOk}
      destroyOnClose
    >
      <Table
        className="tm-table"
        pagination={false}
        scroll={{ y: 480 }}
        dataSource={dataSource}
        rowSelection={{
          type: 'radio',
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
          },
        }}
        columns={[
          {
            title: '姓名',
            dataIndex: 'agentName',
            align: 'center',
          },
          {
            title: '客服类型',
            dataIndex: 'agentType',
            align: 'center',
            render: (value, record, index) => {
              return (
                <span>
                  {value === 'FEEDBACK'
                    ? '售后客服'
                    : value === 'ADMIN'
                    ? '管理员'
                    : value === 'EXCLUSIVE'
                    ? '专属客服'
                    : null}
                </span>
              );
            },
          },
        ]}
      />
    </Modal>
  );
};
